import { BrickContext, ActionBrick, registerBrick, QueryResult } from 'olympe';
import {getLogger} from "@olympeio/core";

export default class GetSizeOfList extends ActionBrick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {Array} list
     * @param {function()} forwardEvent
     * @param {function(number)} setSize
     */
    update($, [list], [forwardEvent, setSize]) {
        if (Array.isArray(list)) {
            setSize(list.length);
            forwardEvent();
        } else if(list instanceof QueryResult) {
            setSize(list.size());
            forwardEvent();
        } else {
            getLogger('Get Size Of List').error('TypeError: the list should be of type Array or QueryResult');
        }
    }
}

registerBrick('0192dce4c545b3fa69b2', GetSizeOfList);
